import { useEffect, useState } from 'react';
import axios from 'axios';
import baseURL from '../Config';

// Refresh the authenticated user's own permissions, including sessions opened
// before an administrator changed their module selection.
export default function useModuleAccessRefresh(userId, token, mustChangePassword) {
    const [, setRevision] = useState(0);
    useEffect(() => {
        if (!userId || !token || token === 'dev-bypass-token' || mustChangePassword) return;
        let cancelled = false;
        let pending = false;
        const refresh = async () => {
            if (pending) return;
            pending = true;
            try {
                const response = await axios.get(`${baseURL}adminAuthentication/moduleAccess`, {
                    headers: { authorization: `Bearer ${token}` }
                });
                if (cancelled || !Object.prototype.hasOwnProperty.call(response.data?.data || {}, 'moduleAccessOverride')) return;
                let changed = false;
                for (const key of ['userDetails', 'adminUser']) {
                    const stored = JSON.parse(localStorage.getItem(key) || 'null');
                    if (stored?.data?.adminUser?._id !== userId) continue;
                    const currentToken = stored.data.token || stored.data.accessToken;
                    if (currentToken !== token) continue;
                    const override = response.data.data.moduleAccessOverride;
                    if (JSON.stringify(stored.data.adminUser.moduleAccessOverride) === JSON.stringify(override)) continue;
                    stored.data.adminUser.moduleAccessOverride = override;
                    delete stored.data.adminUser.effectiveModules;
                    localStorage.setItem(key, JSON.stringify(stored));
                    changed = true;
                }
                if (changed) setRevision((value) => value + 1);
            } catch (error) {
                // Keep the last known permissions during a network outage.
                // API authorization remains enforced by the server.
            } finally {
                pending = false;
            }
        };
        refresh();
        window.addEventListener('focus', refresh);
        const interval = window.setInterval(refresh, 60000);
        return () => {
            cancelled = true;
            window.removeEventListener('focus', refresh);
            window.clearInterval(interval);
        };
    }, [userId, token, mustChangePassword]);
}
